import { DevConfigPanel as SharedDevConfigPanel } from 'Components/DevConfigPanel';

export const CourseDevConfigPanel = () => (
  <SharedDevConfigPanel showPagination={false} panelWidth={280} rightOffset="-22em" />
);
